export function mapLoader() {
	const lazyFrames = document.querySelectorAll('iframe[data-src]');
	lazyFrames.forEach(function(iframe) {
		iframe.setAttribute('src', iframe.getAttribute('data-src'));
		iframe.removeAttribute('data-src');
	});
}
